import * as React from 'react';
const AvatarContext = /*#__PURE__*/React.createContext({});
export default AvatarContext;